import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  actionIcon: {
    color: '#005EB2',
  },
}));
